import 'babel-polyfill'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import less from 'less'
Vue.use(less)

import $mixins from './mixins/index.js'
Vue.mixin($mixins)

// axios数据对接
import axiosAjax from './assets/js/axios.js'
Vue.prototype.$axios = axiosAjax;
//vuex
import store from './store'
Vue.prototype.$store = store

//一些通用的函数集合
import commomConfig from './assets/js/common.js'
Vue.prototype.$common = commomConfig

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js